// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

window.SpeechSDK = require('./distrib/lib/microsoft.cognitiveservices.speech.sdk.js');




//////////////////
// WEBPACK FOOTER
// ./bundleApp.js
// module id = 20
// module chunks = 0